import { useTheme } from 'styled-components';
import { AccountType } from 'src/types';
import {
  ImageContainer,
  SuccessContainer,
  SuccessHeader,
  SuccessText,
} from '../ConfirmationContainer.styles';
import LoginContainer from '../LoginContainer';

interface Props {
  headerText?: string;
  successText?: string;
  kind?: AccountType;
}

export const ResetPasswordConfirmation = ({
  headerText,
  successText,
  kind,
}: Props) => {
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  return (
    <LoginContainer
      includeForm={false}
      data-testid="password-confirmation"
      kind={kind ?? AccountType.App}
    >
      <SuccessContainer data-testid="app-password-reset-success-message">
        <ImageContainer>
          <img src={emptyStateSrc} alt="Success" width={'100%'} />
        </ImageContainer>
        <SuccessHeader>
          {headerText ?? 'Password updated successfully'}
        </SuccessHeader>
        <SuccessText>
          {successText ??
            'Your password is now updated. Open the Vault Reporting App and log in with your new password to continue where you left off.'}
        </SuccessText>
      </SuccessContainer>
    </LoginContainer>
  );
};

export default ResetPasswordConfirmation;
